import React from 'react';

export const ICLocation: React.FC = () => {
    return (
        <svg
            fill="none"
            height={24}
            width={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.054 7.62l-9.032 4.864c-.445.24-.293.914.212.94l4.944.248a.5.5 0 01.451.347l1.193 3.73c.157.49.86.453.966-.05l1.992-9.536a.5.5 0 00-.726-.542z"
                fill="#E5105A"
            />
        </svg>
    );
};
